var _style, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 580 580",
    style: {
      enableBackground: "new 0 0 580 580"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#72CCC5;}\n\t.st1{fill:#11BBA3;}\n\t.st2{fill:#66BF00;}\n\t.st3{fill:#58AB23;}\n\t.st4{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 290,
    cy: 290,
    r: 289.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.5,288.8c1-138.7,99.3-253.8,229.6-281.3c-20-4.5-40.7-7-62-7.1C132.1-0.8,1.5,128,0.4,287.9 S128,578.5,287.9,579.6c21.3,0.2,42.1-2,62.1-6.2C220.1,544.1,123.5,427.5,124.5,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    className: "st2",
    d: "M462.1,238.6l-27.3,8.9c-4.1,1.3-7.4,4.6-8.8,8.7l-8.7,25.3c-1.9,5.6-7.2,9.4-13.2,9.3 l-27.3-0.2c-2.7,0-5.4-0.8-7.6-2.4L335,265.1c-2.3-1.5-4.9-2.4-7.6-2.4l-40.2-0.3c-6.3,0-11.9,4.2-13.5,10.4l-8.8,34.2 c-1.6,6.1-7.1,10.4-13.5,10.4l-24.4-0.2c-4,0-7.8,1.7-10.4,4.6l-87.9,99.1c-3.2,3.7-4.3,8.8-2.8,13.4l8.4,25.9 c1.6,5,5.9,8.6,11.1,9.4l87.1,13.1c0.6,0.1,1.3,0.1,1.9,0.2l26.6,0.2c7.6,0.1,13.7,6.3,13.7,13.9l-0.2,34.7c0,4.2,1.8,8.2,5.1,10.8 l39.1,31.7c2.9,2.4,6.7,3.5,10.4,3c140.7-18.9,249.6-138.9,250.6-285c0.3-41.2-8-80.5-23.3-116.1c-2.2-5-7.1-8.3-12.6-8.3 l-48.5-0.3c-6.6,0-12.3,4.6-13.6,11l-10.4,50C470.3,233.1,466.8,237.1,462.1,238.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    className: "st2",
    d: "M462.1,238.6l-27.3,8.9c-4.1,1.3-7.4,4.6-8.8,8.7l-8.7,25.3 c-1.9,5.6-7.2,9.4-13.2,9.3l-27.3-0.2c-2.7,0-5.4-0.8-7.6-2.4L335,265.1c-2.3-1.5-4.9-2.4-7.6-2.4l-40.2-0.3 c-6.3,0-11.9,4.2-13.5,10.4l-8.8,34.2c-1.6,6.1-7.1,10.4-13.5,10.4l-24.4-0.2c-4,0-7.8,1.7-10.4,4.6l-87.9,99.1 c-3.2,3.7-4.3,8.8-2.8,13.4l8.4,25.9c1.6,5,5.9,8.6,11.1,9.4l87.1,13.1c0.6,0.1,1.3,0.1,1.9,0.2l26.6,0.2 c7.6,0.1,13.7,6.3,13.7,13.9l-0.2,34.7c0,4.2,1.8,8.2,5.1,10.8l39.1,31.7c2.9,2.4,6.7,3.5,10.4,3 c140.7-18.9,249.6-138.9,250.6-285c0.3-41.2-8-80.5-23.3-116.1c-2.2-5-7.1-8.3-12.6-8.3l-48.5-0.3c-6.6,0-12.3,4.6-13.6,11 l-10.4,50C470.3,233.1,466.8,237.1,462.1,238.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.8,257.4l37.1-60.8c1.3-2.1,3.3-3.7,5.6-4.4l72.3-23.5c4.2-1.4,7.1-5.3,7.1-9.7l0.4-56 c0-3.4-1.7-6.7-4.5-8.6l-8.5-5.8c-8.4-5.7-4.3-18.9,5.8-18.8l0,0c4.4,0,8.4-2.8,9.8-7L376,24.5c1.9-5.5-1.2-11.6-6.8-13.2 c-24.5-7-50.4-10.8-77.1-11C145.3-0.7,23.3,107.6,3.3,249c-0.5,3.7,1,7.3,4,9.5L25,272c2,1.5,4.4,2.2,6.8,2.1l197.8-11.8 C233,262.1,236.1,260.3,237.8,257.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M354.1,7.5c-20-4.5-40.7-7-62-7.1C143.3-0.7,19.9,110.6,2.5,254.9L28,274.3l97.3-5.8 C135.2,139,230.2,33.6,354.1,7.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.144,
    y1: 579.9124,
    x2: 282.856,
    y2: 0.08762305,
    gradientTransform: "matrix(0.7122 -0.702 0.702 0.7122 -120.1114 287.0538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 290,
    cy: 290,
    r: 290
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.cac762fa90bb118e5ea929a066916a5e.svg";
export { ForwardRef as ReactComponent };